import { Locale } from '@ae/shared';

export enum AEXSection {
  Experience = 'experience',
  Walk = 'walk',
}

export enum AEXCategory {
  Culture = 'culture',
  Nature = 'nature',
  Sport = 'sport',
  Terroir = 'terroir',
}

export const AEXCategoryIds = {
  [AEXCategory.Culture]: 85,
  [AEXCategory.Nature]: 2,
  [AEXCategory.Sport]: 14,
  [AEXCategory.Terroir]: 1,
};

const sectionPath = (section: AEXSection, locale: Locale): string => {
  if (section === AEXSection.Experience) {
    switch (locale) {
      case Locale.De:
      case Locale.En:
        return 'search';
      case Locale.Fr:
        return 'recherche';
      case Locale.Nl:
      default:
        return 'zoek';
    }
  } else if (section === AEXSection.Walk) {
    switch (locale) {
      case Locale.De:
      case Locale.En:
        return 'hikes';
      case Locale.Fr:
        return 'balades';
      case Locale.Nl:
      default:
        return 'wandelingen';
    }
  }
  return '';
};

export const useBuildAEXUrl = () => {
  const buildUrl = ({
    domain,
    locale,
    lat,
    long,
    rate,
    section,
    category,
  }: {
    domain: string;
    locale: Locale;
    lat?: string;
    long?: string;
    rate?: number;
    section: AEXSection;
    category?: AEXCategory;
  }): string => {
    const path = `${domain}/experience/${sectionPath(section, locale)}`;

    const params = new URLSearchParams();
    if (rate) {
      params.set('rate', String(rate));
    }
    if (category) {
      params.set('field_category_target_id', String(AEXCategoryIds[category]));
    }
    if (lat && long) {
      params.set('latlon', `${lat},${long}`);
    }

    if (params.toString() === '') {
      return path;
    }
    return `${path}?${params}`;
  };

  return { buildUrl };
};
